import { useLazyLoadQuery } from 'react-relay';

import BylineSmartLinksQuery, {
	type BylineSmartLinksQuery as BylineSmartLinksQueryType,
} from '../queries/__generated__/BylineSmartLinksQuery.graphql.ts';

import {
	normalizeOutboundBylineSsrState,
	OUTBOUND_BYLINE_SAMPLE_LIMIT,
	type OutboundBylineSsrState,
} from './outboundBylineSsrState.ts';

/**
 * Reads the page's outgoing links before paint, so the placeholder and the loaded byline size the
 * icon stack from the same apps.
 *
 * `store-only` because this renders inside the loading placeholder: suspending or fetching would
 * stall the very thing covering the wait. Variables must match `preloadOutboundBylineSsrState`, or
 * the read silently misses the preloaded entry and reserves nothing.
 */
export const useOutboundBylineSsrState = (
	contentId: string | undefined,
): OutboundBylineSsrState | undefined => {
	const data = useLazyLoadQuery<BylineSmartLinksQueryType>(
		BylineSmartLinksQuery,
		{
			contentId: contentId ?? '',
			first: OUTBOUND_BYLINE_SAMPLE_LIMIT,
			smartLinksFromDraft: false,
		},
		{ fetchPolicy: 'store-only' },
	);

	if (contentId === undefined) {
		return undefined;
	}

	return normalizeOutboundBylineSsrState(contentId, data);
};
